var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 3.69998C14.6 5.6882 12.9882 7.29998 11 7.29998C9.01173 7.29998 7.39995 5.6882 7.39995 3.69998C7.39995 1.71175 9.01173 0.0999756 11 0.0999756C12.9882 0.0999756 14.6 1.71175 14.6 3.69998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.09998C20.6 7.42546 19.5254 8.49998 18.1999 8.49998C16.8745 8.49998 15.8 7.42546 15.8 6.09998C15.8 4.77449 16.8745 3.69998 18.1999 3.69998C19.5254 3.69998 20.6 4.77449 20.6 6.09998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 14.5C15.8 11.849 13.6509 9.69998 11 9.69998C8.34898 9.69998 6.19995 11.849 6.19995 14.5V18.1H15.8V14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 6.09998C6.19995 7.42546 5.12543 8.49998 3.79995 8.49998C2.47447 8.49998 1.39995 7.42546 1.39995 6.09998C1.39995 4.77449 2.47447 3.69998 3.79995 3.69998C5.12543 3.69998 6.19995 4.77449 6.19995 6.09998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1999 18.1V14.5C18.1999 13.235 17.8737 12.0462 17.3008 11.0132C17.5882 10.9393 17.8895 10.9 18.1999 10.9C20.1882 10.9 21.7999 12.5118 21.7999 14.5V18.1H18.1999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69907 11.0132C4.12617 12.0462 3.79995 13.235 3.79995 14.5V18.1H0.199951V14.5C0.199951 12.5118 1.81173 10.9 3.79995 10.9C4.1104 10.9 4.41167 10.9393 4.69907 11.0132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.61a3c27b2720476dd824c69cb4af5e08.svg";
export { ForwardRef as ReactComponent };